window.Reserva = Backbone.Model.extend({

});

window.Reservas = Backbone.Collection.extend({
    model: Reserva


});